import { render, staticRenderFns } from "./ComSelectMsgIndex.vue?vue&type=template&id=3de6c944&scoped=true"
import script from "./ComSelectMsgIndex.vue?vue&type=script&lang=js"
export * from "./ComSelectMsgIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de6c944",
  null
  
)

export default component.exports